import { memo } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { NavHashLink as NavLink } from 'react-router-hash-link';
import { Box, Flex, Text } from "@chakra-ui/react";

import { MdOutlineWidgets, MdOutlineMoveToInbox } from 'react-icons/md';
import { BiTargetLock } from "react-icons/bi";
import { determineIsNonCustomerUserAccount } from '../../../../profile/helpers/user-helper';


function NavigationLink({ title, linkPath, newUserTourIsActive, ...rest }) {

	const renderNavIcon = (linkPath) => {
		switch (linkPath) {
			case ('/home'):
			case ('/vault'): {
				return MdOutlineWidgets
			}
			case ('/prospectors'): {
				return BiTargetLock
			}
			case ('/received-rooms'): {
				return MdOutlineMoveToInbox
			}
			default: {
				return null
			}
		}
	}

	return (
		<NavLink to={linkPath}>
			<Flex color="gray.500" {...rest} >
				<Box as={renderNavIcon(linkPath)} boxSize='1.5em' />

				<Text fontSize="1em" fontWeight='400' lineHeight='1.5em' width='max-content' ml="0.5em" textTransform='capitalize'>{title}</Text>

			</Flex>
		</NavLink>
	);
}

function DashboardNavigationMenu({ newUserTourIsActive, isGuestMode }) {

	const isNoOrgUser = determineIsNonCustomerUserAccount()
	const spacing = '5em'

	if (isNoOrgUser || isGuestMode) {
		return null
	} else {
		if (!!newUserTourIsActive) {
			return (
				<Flex direction='row' gap={spacing} data-driver="step-1">
					<Flex color="gray.500">
						<Box as={MdOutlineWidgets} boxSize='1.5em' />

						<Text fontSize="1em" fontWeight='400' lineHeight='1.5em' width='max-content' ml="0.5em" textTransform='capitalize'>Rooms</Text>

					</Flex>

					<Flex color="gray.500">
						<Box as={BiTargetLock} boxSize='1.5em' />

						<Text fontSize="1em" fontWeight='400' lineHeight='1.5em' width='max-content' ml="0.5em" textTransform='capitalize'>Prospectors</Text>

					</Flex>
				</Flex>

			)
		}
		return (
			<Flex direction='row' gap={spacing} data-driver="step-1">
				<NavigationLink title="Rooms" linkPath="/vault" />
				<NavigationLink title="Prospectors" linkPath="/prospectors" />
			</Flex>
		);
	}


}


const mapStateToProps = (state) => {

	return {
		newUserTourIsActive: state.newUserTourIsActive.results
	}
}

export default memo(withRouter(connect(mapStateToProps, null)(DashboardNavigationMenu)))
